import { render, staticRenderFns } from "./RecordSalaryExpenseModal.vue?vue&type=template&id=c6f3d8e2&scoped=true"
import script from "./RecordSalaryExpenseModal.vue?vue&type=script&lang=js"
export * from "./RecordSalaryExpenseModal.vue?vue&type=script&lang=js"
import style0 from "./RecordSalaryExpenseModal.vue?vue&type=style&index=0&id=c6f3d8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f3d8e2",
  null
  
)

export default component.exports